export default "__VITE_ASSET__BRox7DTc__"